import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Selected work item backed by the `?item=<public_id>` URL param, so the detail
 * drawer is deep-linkable (copy-link) and survives reload. Drop-in for the old
 * `useState<string | null>` — same `[selected, setSelected]` shape.
 */
export function useSelectedWorkItem(): [string | null, (id: string | null) => void] {
  const [params, setParams] = useSearchParams();
  const selected = params.get('item');

  const setSelected = useCallback(
    (id: string | null) => {
      setParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (id) next.set('item', id);
          else next.delete('item');
          return next;
        },
        { replace: true },
      );
    },
    [setParams],
  );

  return [selected, setSelected];
}
